<div class="px-3 pt-4">
    <h2 class="modal-title" translate="Settings.AccountSecuritySection.Dialog.EnableAuthenticatorApp"></h2>
</div>

<app-enable-authenticator-app-info *ngIf="step === 1" (password)="checkPassword($event);" (close)="close();"></app-enable-authenticator-app-info>

<app-enable-authenticator-app-qr *ngIf="step === 2" [authenticatorData]="authenticatorData" (copy)="copySecretToClipboard();" (code)="check2FactorCode($event);" (close)="close();"></app-enable-authenticator-app-qr>

<app-enable-authenticator-app-recovery-code *ngIf="step === 3" [recoveryCodes]="recoveryCodes" (copy)="copyRecoveryCodesToClipboard();" (close)="close();"></app-enable-authenticator-app-recovery-code>